module.exports = __webpack_public_path__ + "img/browser-open.b43ad085.png";